/** @format */

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './CrmCard.css';
export default function CrmCard({ crmimage, crmpath }) {
  const [isActive, setIsActive] = useState(false);
  const toggleButton = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    event.stopPropagation();
    event.preventDefault();
    setIsActive(!isActive);
  };
  return (
    <Link
      to={`${crmpath}/listings`}
      className="crm_card">
      <img
        src={crmimage}
        alt="crmimage"
      />
      <Link
        to={`${crmpath}/settings`}
        className="setting">
        <div className="setting_wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none">
            <path
              d="M2.38876 9.22879C2.85026 7.80274 3.60856 6.49062 4.61376 5.37879C4.69688 5.28693 4.80542 5.22185 4.9256 5.1918C5.04579 5.16175 5.17219 5.1681 5.28876 5.21004L7.68626 6.06754C7.85693 6.12848 8.03882 6.15159 8.21932 6.13525C8.39981 6.11891 8.5746 6.06351 8.73156 5.97291C8.88851 5.8823 9.02389 5.75864 9.12831 5.61051C9.23272 5.46238 9.30368 5.29332 9.33626 5.11504L9.79376 2.60754C9.81585 2.48547 9.87377 2.37275 9.96014 2.28371C10.0465 2.19466 10.1574 2.13334 10.2788 2.10754C11.7432 1.7957 13.2568 1.7957 14.7213 2.10754C14.8426 2.13334 14.9535 2.19466 15.0399 2.28371C15.1262 2.37275 15.1842 2.48547 15.2063 2.60754L15.6638 5.11504C15.6963 5.29332 15.7673 5.46238 15.8717 5.61051C15.9761 5.75864 16.1115 5.8823 16.2685 5.97291C16.4254 6.06351 16.6002 6.11891 16.7807 6.13525C16.9612 6.15159 17.1431 6.12848 17.3138 6.06754L19.7125 5.21004C19.8292 5.16825 19.9557 5.1621 20.0759 5.19237C20.1961 5.22264 20.3045 5.28796 20.3875 5.38004C21.3925 6.4915 22.1508 7.80319 22.6125 9.22879C22.6505 9.34666 22.6526 9.47316 22.6185 9.59222C22.5845 9.71129 22.5158 9.81756 22.4213 9.89754L20.4775 11.5475C20.3394 11.6649 20.2285 11.8108 20.1524 11.9753C20.0764 12.1398 20.037 12.3188 20.037 12.5C20.037 12.6812 20.0764 12.8603 20.1524 13.0248C20.2285 13.1892 20.3394 13.3352 20.4775 13.4525L22.4213 15.1025C22.5156 15.1827 22.584 15.289 22.6178 15.4081C22.6516 15.5271 22.6494 15.6535 22.6113 15.7713C22.1498 17.1973 21.3914 18.5095 20.3863 19.6213C20.3031 19.7131 20.1946 19.7782 20.0744 19.8083C19.9542 19.8383 19.8278 19.832 19.7113 19.79L17.3138 18.9325C17.1431 18.8716 16.9612 18.8485 16.7807 18.8648C16.6002 18.8812 16.4254 18.9366 16.2685 19.0272C16.1115 19.1178 15.9761 19.2414 15.8717 19.3896C15.7673 19.5377 15.6963 19.7068 15.6638 19.885L15.2063 22.3938C15.1839 22.5156 15.1259 22.6281 15.0396 22.7169C14.9532 22.8057 14.8424 22.8668 14.7213 22.8925C13.2569 23.2045 11.7432 23.2045 10.2788 22.8925C10.1574 22.8667 10.0465 22.8054 9.96014 22.7164C9.87377 22.6273 9.81585 22.5146 9.79376 22.3925L9.33626 19.885C9.30368 19.7068 9.23272 19.5377 9.12831 19.3896C9.02389 19.2414 8.88851 19.1178 8.73156 19.0272C8.5746 18.9366 8.39981 18.8812 8.21932 18.8648C8.03882 18.8485 7.85693 18.8716 7.68626 18.9325L5.28876 19.79C5.17207 19.8318 5.04559 19.838 4.9254 19.8077C4.80521 19.7774 4.69673 19.7121 4.61376 19.62C3.60868 18.5086 2.85038 17.1969 2.38876 15.7713C2.35065 15.6535 2.34837 15.5271 2.38219 15.4081C2.41602 15.289 2.48443 15.1827 2.57876 15.1025L4.52251 13.4525C4.66059 13.3352 4.7715 13.1892 4.84757 13.0248C4.92364 12.8603 4.96303 12.6812 4.96304 12.5C4.96303 12.3188 4.92364 12.1398 4.84757 11.9753C4.7715 11.8108 4.66059 11.6649 4.52251 11.5475L2.57876 9.89754C2.48443 9.81741 2.41602 9.71107 2.38219 9.59202C2.34837 9.47296 2.35065 9.34654 2.38876 9.22879ZM10.0013 12.5C10.0013 13.1631 10.2646 13.799 10.7335 14.2678C11.2023 14.7366 11.8382 15 12.5013 15C13.1643 15 13.8002 14.7366 14.269 14.2678C14.7379 13.799 15.0013 13.1631 15.0013 12.5C15.0013 11.837 14.7379 11.2011 14.269 10.7323C13.8002 10.2634 13.1643 10 12.5013 10C11.8382 10 11.2023 10.2634 10.7335 10.7323C10.2646 11.2011 10.0013 11.837 10.0013 12.5Z"
              fill="#D9D9D9"
            />
          </svg>
        </div>
        <div className="setting_arrow_wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="23"
            viewBox="0 0 22 23"
            fill="none">
            <g clip-path="url(#clip0_797_2888)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.3983 10.8519C14.5702 11.0238 14.6667 11.2569 14.6667 11.5C14.6667 11.7431 14.5702 11.9762 14.3983 12.1481L9.21273 17.3337C9.12817 17.4212 9.02702 17.4911 8.91519 17.5391C8.80335 17.5871 8.68307 17.6124 8.56135 17.6135C8.43964 17.6145 8.31893 17.5913 8.20628 17.5453C8.09362 17.4992 7.99127 17.4311 7.9052 17.345C7.81914 17.259 7.75107 17.1566 7.70498 17.044C7.65889 16.9313 7.6357 16.8106 7.63675 16.6889C7.63781 16.5672 7.6631 16.4469 7.71114 16.335C7.75918 16.2232 7.82902 16.1221 7.91657 16.0375L12.4541 11.5L7.91657 6.9625C7.74959 6.78961 7.65719 6.55806 7.65928 6.31771C7.66137 6.07737 7.75777 5.84746 7.92773 5.6775C8.09769 5.50754 8.3276 5.41114 8.56795 5.40905C8.8083 5.40696 9.03985 5.49935 9.21273 5.66633L14.3983 10.8519Z"
                fill="#FAFAFC"
              />
            </g>
            <defs>
              <clipPath id="clip0_797_2888">
                <rect
                  width="22"
                  height="22"
                  fill="white"
                  transform="translate(0 0.5)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </Link>
      <div
        className={`toggle-btn ${isActive ? 'active' : ''}`}
        onClick={toggleButton}>
        <div className="inner-circle"></div>
      </div>
    </Link>
  );
}
